import api from '../api/instance';
import { PortConfig } from '@modules/agent/models/port-config.model';

const AGENT_STARTER_HOST = 'https://local.testsigmaagent.com:8585';
const PORTS_ENDPOINT = '/agent/ports';

const getPorts = (): Promise<PortConfig> => {
  return api
    .get<PortConfig>(`${AGENT_STARTER_HOST}${PORTS_ENDPOINT}`)
    .then((res) => new PortConfig().deserialize(res))
    .catch((err) => Promise.reject(err));
};

export const AgentStarterService = {
  getPorts,
};
